import React from "react";

import "./rma-table-date-column-title.scss";
import { Tooltip } from "../../../../../components/tooltip/tooltip";
import { FONT_COLOR } from "../../../../../components/fonts/font-props";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import Icon from "../../../../../components/icons/icon/icon";
import IconInfo from "../../../../../components/icons/icon-info/icon-info";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import dashboardTranslationsStore from "../../../../../dashboard-translation/stores/dashboard-translations-store";
import { observer } from "mobx-react";
import uiSettingsStore from "../../../../../stores/ui-settings-store";
import { RETURNS_DATE_FIELD } from "../../../../../services/api/ui-settings-service";


const RmaTableDateColumnsTitle: React.FC = observer(() => {
    const { getTranslation } = useDashboardTranslation();
    const showInfoContent = !dashboardTranslationsStore.isLoading && !uiSettingsStore.isLoading
    return (
        <div className="rma-table-date-column-title-container">
            {getTranslation('DATE', 'dashboard-returns-page')}
            {showInfoContent && <Tooltip
                content={
                    <div className="rma-table-date-column-tooltip-container">
                        <FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>
                            {uiSettingsStore.returnsDateField === RETURNS_DATE_FIELD.CREATED && (
                                getTranslation('DATE_TOOLTIP_CREATED', 'dashboard-returns-page')
                            )}
                            {uiSettingsStore.returnsDateField === RETURNS_DATE_FIELD.DELIVERED && (
                                getTranslation('DATE_TOOLTIP_DELIVERED', 'dashboard-returns-page')
                            )}
                            {uiSettingsStore.returnsDateField === RETURNS_DATE_FIELD.SHIPPED && (
                                getTranslation('DATE_TOOLTIP_TRANSIT', 'dashboard-returns-page')
                            )}
                        </FontBody2>
                    </div>
                }
            >
                <Icon Component={IconInfo} />
            </Tooltip>}
        </div>
    );
});

export default RmaTableDateColumnsTitle;
